// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"be2625f5","130":"2c44389e","136":"2c44389e","265":"cfd7e0c2","329":"15f547f8","630":"2c44389e","656":"2c44389e","707":"36a05084","920":"3112b22e"}[chunkId] + ".chunk.css";
};